import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import useUpdateOrderSessionPrintedTime from "@/shared/mutations/orderSessions/useUpdateOrderSessionPrintedTime";
import { formatDate } from "@/shared/utils/helpers";
import { useMutation } from "@tanstack/react-query";

const useOrderSessionReceiptQuery = () => {
  const branchId = useBranchId();
  const updateOrderSessionPrintedTime = useUpdateOrderSessionPrintedTime();
  const query = useMutation({
    mutationFn: ({
      sessionId,
      isCustomerReceipt,
    }: {
      sessionId: number;
      isCustomerReceipt?: number;
    }) =>
      get2(
        `/internal/secure/pos/v1/order/sessions/${branchId}/${sessionId}/receipt`,
        {
          params: {
            printOnlyCustomerReceipt: isCustomerReceipt || 0,
          },
        },
      ),
    onSuccess: (_, { sessionId }) => {
      updateOrderSessionPrintedTime.mutateAsync({
        orderSessionId: sessionId,
        dateTime: formatDate(new Date(), "inputDateTimeWithSeconds"),
      });
    },
  });
  return query;
};

export default useOrderSessionReceiptQuery;
